import { createSelector } from 'reselect';

import { IBank } from '../../types/developer/banks';
import { IApplicationState } from '../../types/redux';
import { getDeveloper } from './getDeveloper';

const emptyBanks = Array.of<IBank>();

const getFskMortgageBanks = (state: IApplicationState) => state.fsk?.mortgageBanks;

export const getBanks = createSelector([getDeveloper, getFskMortgageBanks], (developer, fskMortgageBanks) => {
  if (fskMortgageBanks) {
    return fskMortgageBanks.map((bank, index) => ({
      downPayment: bank.firstPaymentFrom,
      id: index,
      interestRate: bank.rateFrom,
      logo: bank.icon,
      name: bank.bankName,
    }));
  }

  if (!developer) {
    return emptyBanks;
  }

  return developer.banks;
});
